import { createApi } from '@/api/modules/utils'

const baseUrl = '/question_phrase'
const api = createApi(baseUrl)

// 拓展问题短语
export const questionPhraseApi = {
  list: api('list', 'get'),
  config: api('config', 'get'),
  insert: api('insert', 'post'),
  update: api('update', 'post'),
  delete: api('delete', 'get'),
  expand: api('expand', 'post'),
  batchExpand: api('batch_expand', 'post'),
  import: api('import', 'post'),
  importTemplate: api('import_template', 'get')
}
